import React from "react";
import { Box } from "@mui/material";
import { useMyLeaveBarNew, useMyLeaveBarNewProps } from "./use-bar-new";
import { MyLeaveBarItem } from "my-leave/components/bar-item";
import PropTypes from 'prop-types';

export interface MyLeaveBarNewProps extends useMyLeaveBarNewProps {
  onlyBar?: boolean;
}

/**
 *
 * @component
 * @param {MyLeaveBarNewProps} props
 * @param {number} props.requestable
 * @param {number} props.requested
 * @param {number} props.fulfilled
 * @param {boolean} [props.onlyBar=false]
 *
 */
export const MyLeaveBarNew: React.FC<MyLeaveBarNewProps> = (props) => {
  const { barItems } = useMyLeaveBarNew(props);
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
      }}
    >
      {barItems.map((item, index) => (
        <MyLeaveBarItem
          key={item.label}
          {...item}
          isFirst={index === 0}
          isLast={index === barItems.length - 1}
          onlyBar={props.onlyBar}
        />
      ))}
    </Box>
  );
};

MyLeaveBarNew.propTypes = {
  requestable: PropTypes.number.isRequired,
  requested: PropTypes.number.isRequired,
  fulfilled: PropTypes.number.isRequired,
  onlyBar: PropTypes.bool,
};
